// src/axios.js
import axios from 'axios';
// Create an Axios instance

// export const baseURL = 'https://cleanslate.demoo4s.com/';
// export const baseURL = 'https://cleanslate.thesurvey4u.com/';
// export const baseURL = 'https://localhost:7224/';
export const baseURL = 'https://expresscleanslate.com/';
// export const baseURL = 'http://localhost:9080/';

const api = axios.create({
  baseURL: baseURL + 'api/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Optional: Add request interceptor (e.g., attach JWT token)
api.interceptors.request.use(
  (config) => {
    const token = null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.request.use(
  (config) => {
    config.headers.Authorization = "Bearer GajRaj@25";
    return config;
  },
  (error) => Promise.reject(error)
);
export default api;
